import {
  homePath,
  productBookingPath,
  productFormPath,
} from 'presentations/routes/path';
import { ProductType } from 'domains/models/blog_post/productType';
import SubContentBanner from './SubContentBanner';
import SubContentImageBanner from './SubContentImageBanner';

export function getLandingPageUrl(productType: ProductType) {
  switch (productType) {
    case ProductType.Booking:
      return productBookingPath();
    case ProductType.Form:
      return productFormPath();
    case ProductType.Calendar:
      return homePath();
    // return productCalendarPath();
    default:
      break;
  }
  return homePath();
}

export const defaultAdId = 'default';
// export const subImageAdId = '202310-5.ja.png';
export const subImageAdId = defaultAdId;
export const modalImageAdId = '202310-6.ja.png';
export const availableAdIds = [
  defaultAdId,
  // '202307-3.ja.png',
  // '202310-1.ja.png',
  // '202310-2.ja.png',
  // '202310-3.ja.png',
  // '202310-4.ja.png',
  '202310-5.ja.png',
  // '202310-6.ja.png',
];

export const showAdSquare = (props: {
  adId: string | null;
  productType?: ProductType;
}) => {
  const productType = props.productType || ProductType.Scheduling;
  return (
    <>
      {props.adId === 'default' ? (
        <SubContentBanner productType={productType} position="display" />
      ) : (
        <SubContentImageBanner
          adId={props.adId}
          position="display"
          productType={productType}
        />
      )}
    </>
  );
};

export const showAdModal = (props: {
  adId: string | null;
  productType?: ProductType;
}) => {
  const productType = props.productType || ProductType.Scheduling;
  return (
    <>
      {props.adId === 'default' ? (
        <SubContentBanner productType={productType} position="modal" />
      ) : (
        <SubContentImageBanner
          adId={'202310-6.ja.png'}
          position="modal"
          productType={productType}
        />
      )}
    </>
  );
};
